// theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: '#000', // Set the background color here
      },
    },
  },
});

export default theme;
